import { render, staticRenderFns } from "./English.vue?vue&type=template&id=31ecc7a4&scoped=true"
import script from "./English.vue?vue&type=script&lang=ts"
export * from "./English.vue?vue&type=script&lang=ts"
import style0 from "./English.vue?vue&type=style&index=0&id=31ecc7a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ecc7a4",
  null
  
)

export default component.exports